/* eslint-disable no-underscore-dangle */
import React, { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { getUserData } from 'services/indexcServices';

const INDECX_WIDGET_KEY = '5e46926028a0ef00ed5fc759';
const INDECX_WIDGET_ACTION = '6172ebb48f0e965f45af7db5';

const Pesquisa = () => {
  const isMobile = useMediaQuery({ maxWidth: 620 });
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const fetchUserData = async () => {
      const data = await getUserData();
      if (data) {
        setUserData(data);
      }
    };
    fetchUserData();
  }, []);

  useEffect(() => {
    const scriptId = 'indecx-widget-js';
    const widgetContainerId = 'indecx-widget-container';
    const widgetMinimizedId = 'indecx-widget-minimized';

    if (!window.__INDECX_WIDGET_LOADED__) {
      window.__INDECX_WIDGET_LOADED__ = false;
    }

    const adjustWidgetPosition = () => {
      const widget = document.getElementById(widgetContainerId);
      const mini = document.getElementById(widgetMinimizedId);
      const right = isMobile ? '100px' : '150px';

      if (widget) widget.style.setProperty('right', right);
      if (mini) mini.style.setProperty('right', right, 'important');
    };

    const cleanup = () => {
      window.__INDECX_WIDGET_LOADED__ = false;

      const scriptEl = document.getElementById(scriptId);
      if (scriptEl) scriptEl.remove();

      const widget = document.getElementById(widgetContainerId);
      if (widget) widget.remove();

      const mini = document.getElementById(widgetMinimizedId);
      if (mini) mini.remove();
    };

    const loadWidget = () => {
      if (window.__INDECX_WIDGET_LOADED__) {
        adjustWidgetPosition();
        return;
      }

      const existingScript = document.getElementById(scriptId);
      if (existingScript) existingScript.remove();

      cleanup();

      // Buscar dados do primeiro endereço ativo ou usar fallback do localStorage
      const firstAddress = userData?.customerAddresses?.[0];
      const phoneContact = firstAddress?.contacts?.find(
        (c) => c.contactType === 'CELL' || c.contactType === 'PHONE'
      );
      const emailContact = firstAddress?.contacts?.find(
        (c) => c.contactType === 'EMAIL'
      );

      const config = {
        key: INDECX_WIDGET_KEY,
        action: INDECX_WIDGET_ACTION,
        name:
          userData?.corporateName ||
          localStorage.getItem('@UltragazEmpresarial:customerName') ||
          '',
        email:
          userData?.email ||
          emailContact?.contact ||
          localStorage.getItem('@UltragazEmpresarial:loginEmail') ||
          '',
        phone:
          phoneContact?.contact ||
          (userData?.phoneDdd && userData?.phoneNumber
            ? `${userData.phoneDdd}${userData.phoneNumber}`
            : '') ||
          localStorage.getItem('@UltragazEmpresarial:phone') ||
          '',
        indicators: {
          cpf_cnpj:
            userData?.document ||
            localStorage.getItem('@UltragazEmpresarial:document') ||
            'CPF_INFO',
          codCliente:
            userData?.customerCode ||
            localStorage.getItem('@UltragazEmpresarial:customerCode') ||
            'COD_CLIENTE',
          codEndereco:
            userData?.customerSiteId ||
            firstAddress?.siteId ||
            localStorage.getItem('@UltragazEmpresarial:customerSiteId') ||
            'COD_ENDERECO',
          estado:
            firstAddress?.stateCode ||
            localStorage.getItem('@UltragazEmpresarial:estado') ||
            'ESTADO',
          cidade:
            firstAddress?.city ||
            localStorage.getItem('@UltragazEmpresarial:cidade') ||
            'CIDADE',
        },
      };

      const script = document.createElement('script');
      script.id = scriptId;
      script.src =
        'https://indecx-widget.s3.amazonaws.com/widget-production-v3.js';
      script.async = true;

      script.onload = () => {
        if (window.__INDECX_WIDGET_LOADED__) return;

        const { IndeCX } = window;
        if (IndeCX) {
          IndeCX(config);
          window.__INDECX_WIDGET_LOADED__ = true;
          setTimeout(adjustWidgetPosition, 500);
        }
      };

      document.body.appendChild(script);
    };

    if (userData !== null) {
      loadWidget();
    }

    return cleanup;
  }, [isMobile, userData]);

  return null;
};

export default Pesquisa;
